import { useState, useImperativeHandle, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { BaseModal } from "~/components";
import TokenSearch from "../TokenSearch/TokenSearch";
import { useNavigate, useLocation } from "react-router";
import { getMaximiumnPopupHeight } from "../widget/SafeAreaTop/SafeAreaTop";

const ModalTokenList = forwardRef(
    ({ tokenSelectCallback }: { tokenSelectCallback: () => void }, ref) => {
        const { t } = useTranslation();
        const navigate = useNavigate();
        const location = useLocation();
        const [open, setOpen] = useState(false);

        useImperativeHandle(ref, () => ({
            open: () => {
                setOpen(true);
            },
        }));

        return (
            <BaseModal
                className="bg-bg_0 z-[999] flex"
                style={{
                    height: getMaximiumnPopupHeight(),
                }}
                titleType="title"
                title={t("select_token")}
                open={open}
                modal={true}
                onclickHeaderClose={() => setOpen(false)}
                dismissible={true}
                onOpenChange={(bool) => setOpen(bool)}
            >
                <div
                    className="flex relative w-full"
                    style={{ height: "calc(95vh - 3.75rem)" }}
                >
                    <TokenSearch
                        onTokenClick={(token) => {
                            const { chain_id, contract } = token.token_base;
                            navigate(
                                `${location.pathname}?chain_id=${chain_id}&contract=${contract}`,
                                { replace: true }
                            );
                            tokenSelectCallback?.();
                            setOpen(false);
                        }}
                    />
                </div>
            </BaseModal>
        );
    }
);

export default ModalTokenList;
